<template>
  <div>
    <div class="mb-4">
      {{ complimentaryClose }}
    </div>
    <div>
      {{ city.contactName }}
    </div>
    <div>
      {{ city.contactTitle }}
    </div>
    <div v-if="city.contactPhone">
      {{ formatPhone(city.contactPhone) }}
    </div>
    <div v-if="city.contactEmail">
      {{ city.contactEmail }}
    </div>
  </div>
</template>

<script>
import {City} from "@/models/City";

export default {
  props: {
    city: City,
    complimentaryClose: {
      type: String,
      default: () => 'Sincerely,'
    }
  }
}
</script>
